import { NgModule } from "@angular/core";
import { DatatableComponent } from "./datatable.component";
import { FeatherModule } from 'angular-feather';
import { allIcons } from 'angular-feather/icons';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from "@angular/router";
import { dataTableSortableDirective } from "./datatable-sortable.directive";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { FlatpickrModule } from 'angularx-flatpickr';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
    declarations: [
      DatatableComponent,
      dataTableSortableDirective,
    ],
    imports: [
        CommonModule,
        FeatherModule.pick(allIcons),
        RouterModule,
        NgbModule,
        FormsModule,
        MatIconModule,
        ReactiveFormsModule,
        FlatpickrModule.forRoot(),
        TranslateModule,
        NgSelectModule
    ],
    exports: [DatatableComponent]
  })
  export class DatatableModule { }